import CountUp from 'react-countup';

const stats = [
  { value: 1500, label: 'Websites Launched', color: 'from-blue-500 to-blue-700' },
  { value: 90, label: 'Clients', color: 'from-green-500 to-green-700' },
  { value: 550, label: 'Projects Delivered', color: 'from-purple-500 to-purple-700' },
  { value: 45, label: 'Enterprise Clients', color: 'from-pink-500 to-pink-700' },
];

export default function Stats() {
  return (
    <section className="bg-gradient-to-b from-gray-50 to-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((stat, idx) => (
            <div
              key={stat.label}
              className={`rounded-xl shadow-lg bg-gradient-to-br ${stat.color} text-white flex flex-col items-center justify-center py-10`}
            >
              <h2 className="text-5xl font-extrabold mb-2 drop-shadow-lg">
                <CountUp end={stat.value} duration={2} />+
              </h2>
              <p className="text-lg font-semibold tracking-wide drop-shadow">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
